<template>
  <div class="gc_boadcast">
    <v-head></v-head>
    <div class="gc_boadcast_content clearfix">
      <div>
        <span class="gc_boadcast_content_one">
          <a v-link="{name:'n_select', params: { name: gc_boadcast_left.ids}}"> <img :src="gc_boadcast_left.imgs" alt=""></a>
        </span>
      </div>
      <div>
        <span class="gc_boadcast_content_two">
         <a v-link="{name:'n_select', params: { name: gc_boadcast_middle.ids}}"> <img :src="gc_boadcast_middle.imgs" alt=""></a>
        </span>
        <span class="gc_boadcast_content_tre">
          <a v-link="{name:'n_select', params: { name: gc_boadcast_right.ids}}"> <img :src="gc_boadcast_right.imgs" alt=""></a>
         </span>
      </div>
    </div>
    <v-footer></v-footer>
  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          gc_boadcast_left:{
            imgs:"",
            ids:""
          },
          gc_boadcast_middle:{
            imgs:"",
            ids:""
          },
          gc_boadcast_right:{
            imgs:"",
            ids:""
          },

      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/37",
        data:{} ,
        dataType: "json",
        success: function (data) {
          console.log(11122,data);
          if (data) {
            _this.gc_boadcast_left.imgs = data.image;
            _this.gc_boadcast_left.ids = data.id;
          }
        }
      });
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/38",
        data:{} ,
        dataType: "json",
        success: function (data) {
          console.log(333444,data);
          if (data) {
            _this.gc_boadcast_middle.imgs = data.image;
            _this.gc_boadcast_middle.ids = data.id;
          }
        }
      });
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getImageTypeById/39",
        data:{} ,
        dataType: "json",
        success: function (data) {
          console.log(555666,data);
          if (data) {
            _this.gc_boadcast_right.imgs = data.image;
            _this.gc_boadcast_right.ids = data.id;
          }
        }
      });
    }
  }
</script>

<style>
  .gc_boadcast{width: 9rem;margin: 0 auto;}
  .gc_boadcast_content{margin-top: 0.5rem}
  .gc_boadcast_content img{width: 100%;height: 100%}
  .gc_boadcast_content_one{width: 3.55rem;height: 5.7rem;display: inline-block; float: left; margin-right: 0.1rem;}
  .gc_boadcast_content_two{width: 5.35rem;height: 2.30rem;display: inline-block}
  .gc_boadcast_content_tre{width: 5.35rem;height: 3.30rem;display: inline-block;margin-top: 0.05rem;}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .gc_boadcast{width: 100%;margin: 0 auto;}
    .gc_boadcast_content{margin-top: 0.5rem}
    .gc_boadcast_content img{width: 100%;height: 100%}
    .gc_boadcast_content_one{width: 100%;height: auto;display: inline-block; float: left; margin-right: 0.1rem;}
    .gc_boadcast_content_two{width: 100%;height: auto;display: inline-block}
    .gc_boadcast_content_tre{width: 100%;height: auto;display: inline-block;margin-top: 0.05rem;}
  }
</style>




// WEBPACK FOOTER //
// gc_boadcast.vue?90e4fbe8